export const imgs = {
  beverages: {
    sidiali33cl:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_828/v1745231797/product/e0796f6ed25d62e31ee50a26eb3510db.webp',
    sidiali1l:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_640/v1756391657/product/49f8b222a66123993c5422a3fda871ae.webp',
    oulmes1l:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_828/v1747660205/product/418e8d2e349422c75f17a8b749d8fc3d.webp',
    redbull:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_640/v1583089597/marjane_assets/april_prod_reduced/187081_1.webp',
    oringina:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_828/v1754914356/product/cf17d5200305ff8122b852cd981f5f77.webp',
    poms: 'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_828/v1754915414/product/81d2f7cf768da53d750c35729f9d409a.webp',
    coca: 'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_1920/v1754914782/product/9936ea05e2db09db5471cae298f5dfa4.webp',
    cocazero:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_640/v1764335485/product/6bd50618e934840a88e8b261aca0bec6.webp',
    hawai:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_1920/v1754915121/product/f8c34f87861cca09cdf61b8f221e0d70.webp',
    scheppes:
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_828/v1754914133/product/367b63b00de9d4527b0fdb1dc5257ef1.webp',
    '7up':
      'https://res.cloudinary.com/dcphm6bor/image/upload/q_75,f_auto,w_640/v1731586518/product/4812b26eac591de93f41f1f4c2182664.webp',
  },
};
